import { render, staticRenderFns } from "./Moneylog.vue?vue&type=template&id=cb010f3a&scoped=true"
import script from "./Moneylog.vue?vue&type=script&lang=js"
export * from "./Moneylog.vue?vue&type=script&lang=js"
import style0 from "./Moneylog.vue?vue&type=style&index=0&id=cb010f3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb010f3a",
  null
  
)

export default component.exports